import React, { useState } from "react";
// import { useGetArizaQuery, useGetAllQuery } from "../redux/oncoadmin";
import { Table } from "react-bootstrap";
import {
  CheckCircleOutlined,
  RightOutlined,
  LeftOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { Empty } from "antd";
import ReactPaginate from "react-paginate";
import GemoExel from "./ExelGemo";
import { useGetArizaFinishedQuery } from "../../redux/gemo/gemo";

function GemoFinished() {
  const [page, setPage] = useState(0);
  const { data, isLoading } = useGetArizaFinishedQuery(page);
 
    const columns = [
      {
        title: "No",
      },
      {
        title: "ID",
      },
      {
        title: "Muammo",
      },
      {
        title: "Bo`lim",
      },
      {
        title: "Xona",
      },
      {
        title: "Sana",
      },
      {
        title: "Vaqt",
      },
      {
        title: "Tel nomer",
      },
      {
        title: "Bajarilgan ish",
      },
      {
        title: "Xodim",
      },
    ];


  return (
    <div>
      <GemoExel />
      <Table id="table-to-xls" striped bordered hover>
        <thead>
          <tr>
            {columns?.map((item, index) => (
              <th key={index}>{item.title}</th>
            ))}
          </tr>
        </thead>

        {isLoading ? (
          <h1>Loading......</h1>
        ) : data?.totalPage === 0 ? (
          <Empty />
        ) : (
          <tbody>
            {data?.list?.map((item, index) => (
              <tr key={item?.id}>
                <td>{index + 1}</td>
                <td width={100}>{item?.code}</td>
                <td width={400}>{item?.problem}</td>
                <td width={300}>{item?.department}</td>
                <td>{item?.roomNumber}</td>
                <td width={100}>{item?.createdAt.slice(0, 10)}</td>
                <td>{item?.createdAt.slice(11, 16)}</td>
                <td>{item?.phoneNumber}</td>
                <td width={300}>{item?.doneWork}</td>
                <td width={110}>{item?.updatedBy.fullName}</td>
              </tr>
            ))}
          </tbody>
        )}
      </Table>

      <ReactPaginate
        breakLabel="..."
        nextLabel={<RightOutlined />}
        onPageChange={(pag) => setPage(pag.selected)}
        pageRangeDisplayed={5}
        pageCount={data?.totalPage}
        previousLabel={<LeftOutlined />}
        renderOnZeroPageCount={null}
        className="pagination"
        activeClassName="active"
      />
    </div>
  );
}

export default GemoFinished;
